export default "__VITE_ASSET__C2RlS1T1__"